import React, { memo } from "react";
import { DocumentTemplates } from "@feature/document-templates";

const DocumentTemplatesPage: React.FC = memo(() => {
  return (
    <>
      <DocumentTemplates />
    </>
  );
});

export default DocumentTemplatesPage;
